/**
 * True only for http(s) URLs. Use before putting a stored/user-provided value
 * into an href to avoid `javascript:`/`data:` scheme XSS.
 */
export function isSafeHttpUrl(raw?: string | null): boolean {
  if (!raw) {
    return false;
  }
  try {
    const u = new URL(raw);
    return u.protocol === "https:" || u.protocol === "http:";
  } catch {
    return false;
  }
}
